import React, { useEffect } from 'react';
import { Box, Optional, Image } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ColourSwatches from './ColourSwatches';
import ImageNotFound from '../ImageNotFound';
import { getDefaultImage, getColourSwatches, hasValidImage, getModelImage } from './utils';

import themeStyles from './styles/ProductDetails.styles';

const ImageWrapper = themeStyles.apply(Box, 'ImageWrapper');
const ModelImage = themeStyles.apply(Image, 'ModelImage');
const Container = themeStyles.apply(Box, 'Container');

const ModelDetails = ({ layout, selectedExteriorColor, setSelectedExteriorColor }) => {
  const { search } = (typeof window !== 'undefined' && window.location) || {};
  const params = new URLSearchParams(search);
  const paramsObj = Object.fromEntries(params);

  const exteriorColors = layout?.transmission?.exteriorColors;

  useEffect(() => {
    if (paramsObj?.color) {
      setSelectedExteriorColor(paramsObj.color);
    }
  }, []);

  const defaultImage = getDefaultImage(layout);
  const colorSwatches = getColourSwatches(layout, selectedExteriorColor);

  const modelImage = getModelImage(selectedExteriorColor, exteriorColors, defaultImage);
  const isValidImage = hasValidImage(modelImage);

  const { t } = useTranslation();

  return (
    <Container data-testid="cy-price-and-finance-details">
      <Optional when={isValidImage}>
        <ImageWrapper>
          <ModelImage data-testid="cy-model-image" {...modelImage?.value} />
        </ImageWrapper>
      </Optional>
      <Optional when={!isValidImage}>
        <ImageNotFound
          data-testid="cy-no-model-image"
          altTextContent={t('Pages.Models.Exploration.imageComingSoonLabel')}
        />
      </Optional>
      <ColourSwatches
        swatches={colorSwatches}
        title={t('Sub-apps.PriceAndFinance.chooseColorsLabel')}
        setSelected={setSelectedExteriorColor}
        isDark={false}
      />
    </Container>
  );
};

ModelDetails.propTypes = {
  layout: PropTypes.shape({
    transmission: PropTypes.shape({
      exteriorColors: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }),
  selectedExteriorColor: PropTypes.string,
  setSelectedExteriorColor: PropTypes.func,
};

export default ModelDetails;
